import { AiFillStar } from "react-icons/ai";
import {MdKeyboardArrowUp} from 'react-icons/md'

const IMG_URL = "https://image.tmdb.org/t/p/w500";

const Main = ({ title, img, ratings, overview, release }) => {
  return (
    <div className="cards">
      <div className="image">
        <img
          src={
            img == null
              ? "https://images.pexels.com/photos/4205210/pexels-photo-4205210.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
              : IMG_URL + img
          }
          alt={title}
        />
        <MdKeyboardArrowUp className='arrow'/>
      <div className="overview">
        <p>{overview}</p>
      </div>
      </div>
      <div className="desc">
        <h4>{title}</h4>
        <span className='release'> { release}</span>
        <span><AiFillStar className='star' />{ratings}</span>
      
      </div>
     
    </div>
  );
};

export default Main;
